import type { EmbedRouteId } from './sdk-config'

export const EMBED_ROUTE_PATHS: Record<EmbedRouteId, string> = {
  chatui: '/embed/chatui',
  dashboard: '/embed/dashboard',
}

export function isEmbedRouteId(route: unknown): route is EmbedRouteId {
  return typeof route === 'string' && route in EMBED_ROUTE_PATHS
}

export function resolveEmbedRoutePath(route: EmbedRouteId | string | undefined) {
  if (isEmbedRouteId(route)) {
    return EMBED_ROUTE_PATHS[route]
  }

  return EMBED_ROUTE_PATHS.dashboard
}